var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6V24H3V0H15L21 6ZM4 23H20V7H14V1H4V23ZM15 6H19.5L15 1.5V6Z",
    fill: "#040404"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 24,
    height: 9,
    rx: 1,
    fill: "#2B62F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 15C10.8807 15 12 16.1193 12 17.5C12 18.8807 10.8807 20 9.5 20C8.11929 20 7 18.8807 7 17.5C7 16.1193 8.11929 15 9.5 15ZM9.5 16C8.67157 16 8 16.6716 8 17.5C8 18.3284 8.67157 19 9.5 19C10.3284 19 11 18.3284 11 17.5C11 16.6716 10.3284 16 9.5 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15C16.7095 15 17.7186 15.8589 17.9502 17H16.9131C16.707 16.4177 16.1529 16 15.5 16C14.6716 16 14 16.6716 14 17.5C14 18.3284 14.6716 19 15.5 19C16.1529 19 16.707 18.5823 16.9131 18H17.9502C17.7186 19.1411 16.7095 20 15.5 20C14.1193 20 13 18.8807 13 17.5C13 16.1193 14.1193 15 15.5 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5L22 15H23V15.5L21.5 17.5L23 19.5V20H22L21 18.5L20 20H19V19.5L20.5 17.5L19 15.5V15H20L21 16.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15C5.43027 15.0048 6.00353 16.1297 6 17.5C5.99645 18.879 5.43742 19.9998 4 19.9951L2 19.9922L2.0127 15H4ZM3 19L4 19.0117C4.99177 19.015 5 18.1328 5 17.5C5 17.0003 4.96922 16.0033 4 16H3V19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.63e751b120df902fe176bca3d05b0ca4.svg";
export { ForwardRef as ReactComponent };